import { useEffect } from "react";

// Global Alt+L ("Add Comment Log Entry") / Alt+Shift+L ("View Facility Log")
// hotkeys. The legacy ASP app used Ctrl+L / Ctrl+Shift+L (see
// UtilKeyboardCommon.asp case 76: plain fires EVENT_ADDCOMMENT_DEFAULTSTRING
// -> ContainerCommon.vbs/AddCommentLogEntry, shift fires
// EVENT_FACILITYVIEWER_DEFAULTSTRING -> DisplayCommentLog()). This React app
// remaps both to Alt+ (Cmd+ on Mac), same reasoning as
// useSuperSearchShortcut's Alt+S: don't fight the browser for Ctrl+L, which
// natively focuses the address bar.
//
// Mount this once at the app shell level (App.jsx) so both shortcuts work
// from any authenticated screen, not per-page. onTrigger receives
// { shiftKey } so the caller can branch between Add and View.
const useFacilityLogShortcut = (onTrigger, { enabled = true } = {}) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event) => {
      const key = event.key?.toLowerCase();
      const isFacilityLogCombo = (event.altKey || event.metaKey) && key === "l";
      if (!isFacilityLogCombo) return;

      event.preventDefault();
      onTrigger?.({ shiftKey: event.shiftKey });
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onTrigger, enabled]);
};

export default useFacilityLogShortcut;
